import React, { useState } from "react";
import OwLabel from "../../OwLabel/OwLabel";
import { OwFnInput } from "../../OwFnInput/OwFnInput";
import OwDateInput from "../../OwDateInput/OwDateInput";
import { Moment } from "moment-timezone";
import OwButton from "../../OwButton/OwButton";
import ChRobinsonTranportModesEnum from "../../../../models/ChRobinsonTranportModesEnum";
import { useFormik } from "formik";
import IOrder from "../../../../models/IOrder";
import OwSelectOption from "../../OwSelectOption/OwSelectOption";
import moment from "moment";

type Props = {
    weight: number;
    order: IOrder;
    getTransportOptions: (values: any) => void;
    active: boolean;
};

export const ChRobinsonRatesModalSearchForm = (props: Props) => {
    const [shipDate, setShipDate] = useState<Moment | null>(null);
    const [isDisabled, setIsDisabled] = useState(true);

    const transportOptions = [
        { title: "LTL", value: ChRobinsonTranportModesEnum.LTL },
        { title: "TL", value: ChRobinsonTranportModesEnum.TL },
        { title: "Air", value: ChRobinsonTranportModesEnum.Air },
        { title: "Bulk", value: ChRobinsonTranportModesEnum.Bulk },
        { title: "Consol", value: ChRobinsonTranportModesEnum.Consol },
        { title: "Flatbed", value: ChRobinsonTranportModesEnum.Flatbed },
        { title: "IMDL", value: ChRobinsonTranportModesEnum.IMDL },
        { title: "Ocean", value: ChRobinsonTranportModesEnum.Ocean },
    ];

    const formik = useFormik({
        initialValues: {
            weight: props.weight,
            origin: props.order.Shipping_Warehouse?.Address?.postal_code || "",
            destination: props.order.Ship_To?.postal_code || "",
            shipDate: "",
            transportMode: "",
        },
        onSubmit: (values) => {
            props.getTransportOptions(values);
        },
        validate: (values) => {
            const errors: any = {};

            if (!values.weight) {
                errors.weight = "Required";
            }

            if (!values.origin) {
                errors.origin = "Required";
            }

            if (!values.destination) {
                errors.destination = "Required";
            }

            if (!values.shipDate) {
                errors.shipDate = "Required";
            }

            if (!values.transportMode) {
                errors.transportMode = "Required";
            }

            setIsDisabled(Object.keys(errors).length > 0);

            return errors;
        },
    });

    const filterDates = (date: Date): boolean => {
        const currentDay = moment(date);

        if (currentDay.isBefore(moment().subtract(1, "days"))) {
            return false;
        } else if (currentDay.isAfter(moment().add(30, "days"))) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <div className={"ChRobinsonRatesModalSearchForm"}>
            <form onSubmit={formik.handleSubmit}>
                <div className={"mb-4"}>
                    <div>
                        <OwLabel title={"weight"} isBold={true} />
                    </div>
                    <div className={"w-7r d-flex align-items-center"}>
                        <OwFnInput fn={formik.handleChange} name={"weight"} value={formik.values.weight} />
                        <OwLabel title={"lbs"} className={"ms-2"} />
                    </div>
                </div>

                <div className={"mb-2 d-flex"}>
                    <div className={"w-7r"}>
                        <OwLabel title={"origin"} isBold={true} />
                    </div>
                    <div>
                        {props.order.Shipping_Warehouse ? (
                            props.order.Shipping_Warehouse?.name
                        ) : (
                            <OwFnInput fn={formik.handleChange} name={"origin"} value={formik.values.origin} />
                        )}
                    </div>
                </div>

                <div className={"mb-4 d-flex"}>
                    <div className={"w-7r"}>
                        <div>
                            <OwLabel title={"destination"} isBold={true} />
                        </div>
                        <div className={"text-small"}>
                            (<OwLabel title={"postal_code"} />)
                        </div>
                    </div>
                    <div>
                        <OwFnInput fn={formik.handleChange} name={"destination"} value={formik.values.destination} />
                    </div>
                </div>

                <div className={"mb-4 d-flex"}>
                    <div className={"w-7r"}>
                        <OwLabel title={"ship_date"} isBold={true} />
                    </div>
                    <div>
                        <OwDateInput
                            fn={(date: Moment) => {
                                setShipDate(date);
                                formik.setFieldValue("shipDate", date.format("YYYY-MM-DD"));
                            }}
                            selectedDate={shipDate}
                            dateFormat={"MM/dd/yyyy"}
                            filterDate={filterDates}
                        />
                    </div>
                </div>

                <div className={"mb-2"}>
                    <div>
                        <OwLabel title={"transport_mode"} isBold={true} />
                    </div>
                    <div className={"w-10r"}>
                        <OwSelectOption
                            options={transportOptions}
                            fn={formik.handleChange}
                            titleProp={"title"}
                            valueProp={"value"}
                            name={"transportMode"}
                        />
                    </div>
                </div>

                <div className={"mt-4"}>
                    <OwButton title={"start"} type={"submit"} active={props.active} disableOnActive={true} disabled={isDisabled} />
                </div>
            </form>
        </div>
    );
};
